import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { insuranceQueries } from '../../query-factories/insurance-queries';
import { useFiltersStore } from '../../stores/filters.stores';
import { useQueriesWithGlobal } from '../use-queries-with-globals/queries-with-global';

export function useInsurances() {
  const page = useFiltersStore.use['insurances']().pagination.pageIndex + 1;
  const sorting = useFiltersStore.use['insurances']().sorting;
  const filters = useFiltersStore.use['insurances']().filters;
  const queries = useQueriesWithGlobal(insuranceQueries);

  const query = useQuery({
    ...queries.list({ filters: { page, sorting, filters } }),
    placeholderData: keepPreviousData,
  });

  return query;
}

export default useInsurances;
